<template>
  <div class="">
    <div
      class="flex items-center gap-4 p-4 bg-f4f5 shadow-md"
      v-for="(item, index) in Notification"
      :key="'-item' + index"
      @click="readNotification(item)"
    >
      <div
        class="w-12 h-12 rounded-full white-bg flex justify-center items-center"
      >
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/whatsapp.png"
          alt="whatsapp"
          class="w-8 h-8 rounded-full"
        />
      </div>
      <div class="content">
        <h5 class="font-semibold mb-1 fsize14">{{ item.title }}</h5>
        on
        <h4 class="font-semibold mb-1 fsize16">
          {{ item.notificationRedirect }}
        </h4>
        <p>{{ item.subtitle }}</p>
        <p class="fsize12">{{ getDate(item.visibleDate) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { EventBus } from "@/main";
export default {
  data() {
    return {
      Notification: [
        // {
        //   id: "01",
        //   title: "Header1",
        //   desc: "Description1",
        // },
        // {
        //   id: "02",
        //   title: "Header2",
        //   desc: "Description2",
        // },
        // {
        //   id: "03",
        //   title: "Header3",
        //   desc: "Description3",
        // },
      ],
      allNotifications: [],
      notificationC: 0,
    };
  },
  props: {
    isShowNotification: { type: Boolean },
  },
  methods: {
    async getNotification() {
      let notificationC = 0;
      let notifications = [];

      let payload = {
        readStatus: false,
        projectName: this.selectedProject.projectName,
      };
      let { data } = await this.$store.dispatch(
        "getNotify/getAllNotification",
        payload
      );

      this.Notification = data;
      this.notificationC = data.length;
      // for (let i = 0; i < data.length; i++) {
      //   if (data[i].readStatus === false) {
      //     Object.assign(data[i], {
      //       type: "light-primary",
      //       avatar: `${process.env.VUE_APP_GOOGLE_URL}brained-uat/dash/projects/default_project.png`,
      //       avatarName: "default",
      //     });
      //     this.notificationC += 1;
      //   }
      // }
      console.log(notificationC, "count");
      this.$emit("func", this.notificationC);
    },
    async readNotification(item) {
      console.log(item, "selected");
      let payload = {
        id: item._id,
        readStatus: true,
        projectName: this.selectedProject.projectName,
      };

      let { data } = await this.$store.dispatch(
        "getNotify/editNotification",
        payload
      );
      console.log(data, "updated");
      await this.getNotification();
    },
    recallFunc() {
      console.log("event called");
      this.getNotification();
    },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
  },
  async mounted() {
    EventBus.$on("TriggerCommentsNotify", this.recallFunc);
    await this.getNotification();
  },
  beforeDestroy() {
    EventBus.$off("TriggerCommentsNotify", this.recallFunc);
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["selectedProjectDetails"]),
  },
  watch: {
    async isShowNotification(value) {
      if (value == true) {
        await this.getNotification();
      }
    },
  },
};
</script>

<style>
.white-bg {
  background-color: white;
}
.bg-grens {
  background-color: #e9f7e8 !important;
}
.bg-f4f5 {
  background-color: #f4f5f6 !important;
}
.bg-f4f5:hover {
  background-color: white !important;
}
</style>
